import { Box,
  Button, Center, Checkbox, CheckboxGroup, Collapse,
  Container,
  FormControl, FormErrorMessage,
  FormLabel, Heading, HStack, Input, Radio, RadioGroup,
  Spinner, Text, useDisclosure, useToast, VStack
} from "@chakra-ui/react";
import {AxiosResponse} from "axios";
import { Field, Form, Formik } from "formik";
import React, {useEffect, useState} from "react";
import {useMutation, useQuery, useQueryClient} from "react-query";
import {Navigate, useLocation, useNavigate} from "react-router-dom";

import {getCurrentUser as apiGetCurrentUser, submitUserFormEDI} from "../Api";
import {errorToast} from "../helper/ToastHelper";
import {
  useAuthentication,
} from "../hooks/AuthenticationProvider";
import { disableBlurProtection } from "../hooks/BlurProtection";
import {useTheme} from "../hooks/ThemeProvider";
import {Paths, UserStatus} from "../model/Constants";
import {UserDto} from "../model/Dto";
import {authenticationKeys} from "../QueryKeys";
import {enableKeyCommands, isInAvataiSite} from "../Utils";
import TermsAndConditionsModal from "./TermsAndConditionsModal";

type FormParams = {
  qEDI1: string;
  qEDI1e: string;
  qEDI2: string[];
  qEDI3: string;
  qEDI4: string;
  qEDI5: string;
};

const IntroFormEDI = () => {
  const toast = useToast();
  const authentication = useAuthentication();
  const location = useLocation();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { isOpen, onToggle } = useDisclosure()
  const theme = useTheme().theme;

  const [aEDI1, setAEDI1] = useState<string>('');
  const [aEDI1e, setAEDI1e] = useState<string>('');
  const [aEDI2, setAEDI2] = useState<string[]>([]);
  const [aEDI3, setAEDI3] = useState<string>('');
  const [aEDI4, setAEDI4] = useState<string>('');
  const [aEDI5, setAEDI5] = useState<string>('');
  const [isError, setIsError] = useState(true);

  const qEDI2Options=['Oral','Escrito','Literatura','Ninguna'];
/*
  const currentUserQuery = useQuery<AxiosResponse<UserDto>, Error>(
    authenticationKeys.currentUser(),
    apiGetCurrentUser
  );*/

  function qEDI1eIsEnabled() {
      return aEDI1==='Ambos' ||aEDI1==='Uno';
  }

  function updateAEDI1(value:string) {
    setAEDI1(value)
  }

  const handleCheckboxChange = (values: string[]) => {
      // if the newest element selected is 'Ninguna', clear the other options
      if (values[values.length - 1]===qEDI2Options[3])
        setAEDI2([qEDI2Options[3]])

      else {
        // if the previous element was 'Ninguna', only add the new one
        if (values[0]===qEDI2Options[3])
            setAEDI2([values[values.length - 1]])
        else
            setAEDI2(values)
      }
      setIsError(values.length === 0);
  }

  const [acceptsTC, setAcceptsTC] = useState<boolean>(authentication.currentUserQuery?.data?.data?.acceptTerms !== undefined ?
                                                          authentication.currentUserQuery?.data?.data?.acceptTerms : false);


  if ( isInAvataiSite())
    navigate(Paths.HOME, { replace: true });

  disableBlurProtection();
  enableKeyCommands();

  useEffect(() => {
    setAcceptsTC(authentication.currentUserQuery?.data?.data?.acceptTerms !== undefined ?
                authentication.currentUserQuery?.data?.data?.acceptTerms : false);
  }, [authentication]);


  const submitForm = useMutation<AxiosResponse<boolean>, Error, FormParams>(
    (params: FormParams) => {
      return submitUserFormEDI(aEDI1,aEDI1e,aEDI2,aEDI3,aEDI4,aEDI5);
    },
    {
      onSuccess: () => {
        return queryClient.invalidateQueries(authenticationKeys.currentUser());
      },
      onError: () => {
        errorToast(toast, "Ocurrió un error en el servidor");
      },
    }
  );

  if (
    !authentication.currentUserQuery ||
    authentication.currentUserQuery.isLoading
  ) {
    return <Spinner />;
  } else if (
    authentication.currentUserQuery.isError || (authentication.currentUserQuery.data &&
      authentication.currentUserQuery.data?.status !== 401 &&
      (authentication.currentUserQuery.data?.data?.status===UserStatus.USED ||
       !authentication.currentUserQuery.data?.data?.uGroup.includes("EDI")   ))
  )
    return <Navigate to={(Paths.HOME)}
                     state={{ from: location }} replace />;

  else
  return (
    <Container maxW="container.lg">
      <Formik
        initialValues={
          {
            qEDI1: "",
            qEDI1e: "",
            qEDI2: [],
            qEDI3: "",
            qEDI4: "",
            qEDI5: ""
          } as FormParams
        }
        onSubmit={(values: FormParams) =>
            submitForm.mutate(values)
        }
      >
        <Form>
          <Heading paddingTop='4' as='h3' size='lg'>Por favor seleccione las opciones según corresponda</Heading>
            <Box
          borderWidth="1px"
          borderRadius="lg"
          borderColor="gray.300"
          borderStyle="solid"
          marginBlock={5}
          padding={5}>
          <Heading as='h5' size='md'>1. Conocimiento de inglés en el núcleo familiar</Heading>
              <Field name="qEDI1">
                {({ field }: any) => (
                  <FormControl isRequired>
                    <FormLabel htmlFor="qEDI1" paddingTop={4}>¿Alguno(a) de sus padres, madres o encargados(as) habla inglés?</FormLabel>
                    <RadioGroup {...field} id='qEDI1' value={aEDI1}
                                 onChange={(nextValue) => {
                                   field.onChange({ target: { name: 'qEDI1', value: nextValue } });
                                   updateAEDI1(nextValue);
                                 }}>
                      <VStack spacing='15px' alignItems="normal">
                        <Radio value='Ambos'>Sí, ambos</Radio>
                        <Radio value='Uno'>Sí, solo uno de ellos</Radio>
                        <Radio value='No'>No</Radio>
                      </VStack>
                    </RadioGroup>
                  </FormControl>
                )}
              </Field>
      <Collapse in={qEDI1eIsEnabled()} animateOpacity>
          <Field name="qEDI1e">
            {({ field }: any) => (
              <FormControl isRequired={qEDI1eIsEnabled()}>
                <FormLabel htmlFor="qEDI1e" paddingTop={4}>¿Qué tan bien considera que su padres, madres o encargados(as) habla inglés?</FormLabel>
                  <RadioGroup {...field} id='qEDI1e' value={aEDI1e}
                                 onChange={(nextValue) => {
                                   field.onChange({ target: { name: 'qEDI1e', value: nextValue } });
                                   setAEDI1e(nextValue);
                                 }}>
                  <VStack spacing='15px' alignItems="normal">
                    <Radio value='Básico'>Básico, apenas conoce pocas palabras</Radio>
                    <Radio value='Funcional'>Funcional, comprende bastante al leer </Radio>
                    <Radio value='Intermedio'>Intermedio, comprende al escuchar y puede conversar, aunque con dificultad </Radio>
                    <Radio value='Avanzado'>Avanzado, habla fluido y escribe en inglés</Radio>
                  </VStack>
                </RadioGroup>
              </FormControl>
            )}
          </Field>
            </Collapse>
            </Box>
            <Box
          borderWidth="1px"
          borderRadius="lg"
          borderColor="gray.300"
          borderStyle="solid"
          marginBlock={5}
          padding={5}>
          <Heading as='h5' size='md'>2. Modalidad de aprendizaje del inglés durante la secundaria</Heading>
          <Field name="qEDI2">
            {({ field }: any) => (
              <FormControl  isInvalid={isError}>
                <FormLabel htmlFor="qEDI2" paddingTop={4}>¿Cómo describiría el enfoque principal de las lecciones de inglés que usted recibió en la secundaria? (Opción múltiple)</FormLabel>
                <CheckboxGroup {...field} id='qEDI2' value={aEDI2}
                                 onChange={(nextValues: string[]) => {
                                   field.onChange({ target: { name: 'qEDI2', value: nextValues } });
                                   handleCheckboxChange(nextValues);
                                 }}>
                  <VStack spacing='15px' alignItems="normal">
                    <Checkbox value={qEDI2Options[0]}
                      >Oral (conversación, audición)</Checkbox>
                    <Checkbox value={qEDI2Options[1]}
                      >Escrito (gramática, redacción) </Checkbox>
                    <Checkbox value={qEDI2Options[2]}
                      >Literatura inglesa y análisis de textos</Checkbox>
                    <Checkbox value={qEDI2Options[3]}
                      >No recibí lecciones de inglés</Checkbox>
                  </VStack>
                </CheckboxGroup>
                {isError && <FormErrorMessage>Debe seleccionar al menos una opción.</FormErrorMessage>}
              </FormControl>
            )}
          </Field>
            </Box>
            <Box
          borderWidth="1px"
          borderRadius="lg"
          borderColor="gray.300"
          borderStyle="solid"
          marginBlock={5}
          padding={5}>
          <Heading as='h5' size='md'>3. Exposición a materias impartidas en inglés en la secundaria</Heading>
          <Field name="qEDI3">
            {({ field }: any) => (
              <FormControl isRequired>
                <FormLabel htmlFor="qEDI3" paddingTop={4}>Durante la secundaria, ¿cuántas materias recibió parcial o totalmente en inglés?</FormLabel>
                <RadioGroup {...field} id='qEDI3' value={aEDI3}
                                 onChange={(nextValue) => {
                                   field.onChange({ target: { name: 'qEDI3', value: nextValue } });
                                   setAEDI3(nextValue);
                                 }}>
                  <VStack spacing='15px' alignItems="normal">
                    <Radio value='Ninguna'>Ninguna</Radio>
                    <Radio value='Algunas'>Algunas, menos del 50% del tiempo lectivo</Radio>
                    <Radio value='Varias'>Varias, más del 50% del tiempo lectivo</Radio>
                    <Radio value='Mayoría'>La mayoría o todas (programa bilingüe)</Radio>
                  </VStack>
                </RadioGroup>
              </FormControl>
            )}
          </Field>
            </Box>
            <Box
          borderWidth="1px"
          borderRadius="lg"
          borderColor="gray.300"
          borderStyle="solid"
          marginBlock={5}
          padding={5}>
          <Heading as='h5' size='md'>4. Uso del inglés en la vida cotidiana</Heading>
          <Field name="qEDI4">
            {({ field }: any) => (
              <FormControl isRequired>
                <FormLabel htmlFor="qEDI4" paddingTop={4}>¿Con qué frecuencia usa el inglés fuera del entorno académico (música, videos, redes sociales, videojuegos, series, etc.)?</FormLabel>
                <RadioGroup {...field} id='qEDI4' value={aEDI4}
                                 onChange={(nextValue) => {
                                   field.onChange({ target: { name: 'qEDI4', value: nextValue } });
                                   setAEDI4(nextValue);
                                 }}>
                  <VStack spacing='15px' alignItems="normal">
                    <Radio value='Nunca'>Nunca</Radio>
                    <Radio value='Rara vez'>Rara vez</Radio>
                    <Radio value='Algunas veces'>Algunas veces a la semana</Radio>
                    <Radio value='Casi diariamente'>Casi diariamente</Radio>
                    <Radio value='Diariamente'>Todos los días</Radio>
                  </VStack>
                </RadioGroup>
              </FormControl>
            )}
          </Field>
            </Box>
            <Box
          borderWidth="1px"
          borderRadius="lg"
          borderColor="gray.300"
          borderStyle="solid"
          marginBlock={5}
          padding={5}>
          <Heading as='h5' size='md'>5. Situación laboral</Heading>
          <Field name="qEDI5">
            {({ field }: any) => (
              <FormControl isRequired>
                <FormLabel htmlFor="qEDI5" paddingTop={4}>¿Actualmente trabaja de forma remunerada?</FormLabel>
                <RadioGroup {...field} id='qEDI5' value={aEDI5}
                                 onChange={(nextValue) => {
                                   field.onChange({ target: { name: 'qEDI5', value: nextValue } });
                                   setAEDI5(nextValue);
                                 }}>
                  <VStack spacing='15px' alignItems="normal">
                    <Radio value='Tiempo completo'>Sí, tiempo completo</Radio>
                    <Radio value='Medio tiempo'>Sí, medio tiempo</Radio>
                    <Radio value='Ocasional'>Sí, de manera ocasional o por proyectos</Radio>
                    <Radio value='No'>No</Radio>
                  </VStack>
                </RadioGroup>
              </FormControl>
            )}
          </Field>
            </Box>

        <TermsAndConditionsModal acceptsTC={acceptsTC} setAcceptsTC={setAcceptsTC}
         textColor={theme.TEXT_PRIMARY} stayLogged={true}/>

          <Center>
            <Button
              mt={4}
              margin={5}
              colorScheme="teal"
              type="submit"
              isLoading={authentication.loginMutation?.isLoading}
              disabled={!acceptsTC}
              _disabled={{
                cursor: 'default',
                opacity: '0.4',
              }}
            >
              Confirmar
            </Button>
          </Center>
        </Form>
      </Formik>
    </Container>
  );
};

export default IntroFormEDI;
